import script from "./LanguageSelectorItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSelectorItem.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__